import script from "./EnrollModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EnrollModal.vue?vue&type=script&setup=true&lang=js"

import "./EnrollModal.vue?vue&type=style&index=0&id=3481994a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3481994a"]])

export default __exports__